import { useLocation } from '@reach/router';
import createIconMenu from 'assets/icons/icon-create-proposal-12-negative.svg';
import createIconBtn from 'assets/icons/icon-create-proposal-12.svg';
import { addDays } from 'date-fns';
import { Link } from 'gatsby';
import { Proposal, useProposals } from 'modules/proposals';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useScrollPosition } from 'shared/hooks';

interface Props {
  className: string;
  proposal: Proposal;
  btnSelector?: string;
  isDrawerBtn?: boolean;
}

export const CreateFromTemplateButton: React.FC<Props> = ({
  className,
  proposal,
  btnSelector,
  isDrawerBtn,
}) => {
  const { createEntityWithImagesAsync, reserveProposalId } = useProposals();
  const { pathname, search } = useLocation();
  const { formatMessage } = useIntl();
  const scrollPosition = useScrollPosition();
  const id = reserveProposalId();

  function onClick() {
    createEntityWithImagesAsync(
      id,
      new Proposal({
        ...proposal,
        publishStatus: 'draft',
        creationDateTime: Date.now(),
        displayDateTime: Date.now(),
        validUntilDateTime: +new Date(addDays(new Date(), 14)),
      }),
    );
  }

  return (
    <Link
      to={formatMessage({ id: 'routes.new-proposal' }, { id })}
      state={{
        lastPageUrl: `${pathname}${search}`,
        scrollY: String(scrollPosition),
      }}
      className={`${className} btn__icon__fill`}
      onClick={onClick}
      data-cy={btnSelector}
    >
      {isDrawerBtn ? (
        <img
          src={createIconMenu}
          alt="Create new proposal icon"
          className="btn__icon btn__icon__left"
        />
      ) : (
        <img
          src={createIconBtn}
          alt="Create new proposal icon"
          className="btn__icon btn__icon__left"
        />
      )}
      <FormattedMessage id="buttons.create-from-template" />
    </Link>
  );
};
